import { render, staticRenderFns } from "./PublicShareAuth.vue?vue&type=template&id=ae90a774"
import script from "./PublicShareAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicShareAuth.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublicShareAuth.vue?vue&type=style&index=0&id=ae90a774&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports